<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import type { WholesalePartnerCardProps } from "./WholesalePartnerCardProps.js";

	const { partner }: WholesalePartnerCardProps = $props();
</script>

<article lang={partner.lang} class="rounded-2xl border border-fcrlightgray-300 flex flex-col w-81.5 p-4 gap-8">
	<q><Formatted text={partner.cite} /></q>
	<div class="mt-auto flex items-center justify-between">
		<div class="text-fcrdarkgray font-medium text-5/tighter font-antipol grow shrink tracking-normal">
			<Formatted text={partner.author} />
		</div>
	</div>
</article>
